import type { ConstsConfig } from '../declare'

const consts: ConstsConfig[] = [
  // 时长
  {
    name: 'DURATION_COMMON',
    value: 200
  },
  {
    name: 'DURATION_FADE_IN',
    value: 200
  },
  {
    name: 'DURATION_ARROW_ROTATE',
    value: 200
  },
  // 正则
  {
    name: 'REG_PHONE',
    value: /^1(3[0-9]|4[01456879]|5[0-35-9]|6[2567]|7[0-8]|8[0-9]|9[0-35-9])\d{8}$/
  },
  {
    name: 'REG_EMAIL',
    value: /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(\.[a-zA-Z0-9_-])+/
  },
  {
    name: 'REG_IMAGE',
    value: /\.(png|jpg|gif|jpeg|webp)$/
  },
  {
    name: 'REG_WEBSITE',
    value: /^((https?|ftp|smtp):\/\/)?(www.)?[a-z0-9]+\.[a-z]+(\/[a-zA-Z0-9#]+\/?)*$/
  },
  {
    name: 'REG_IP',
    value: /^((25[0-5]|(2[0-4]|1\d|[1-9]|)\d)\.?\b){4}$/
  },
  // 密码登录
  {
    name: 'GRANT_TYPE_PASSWORD',
    value: 0
  },
  // 验证码登录
  {
    name: 'GRANT_TYPE_PHONECODE',
    value: 1
  },
  // token 刷新登录
  {
    name: 'GRANT_TYPE_REFRESH',
    value: 2
  },
  // 顶级菜单标志
  {
    name: 'TOP_MENU_LEVEL',
    value: 0
  },
  // 分页请求一页请求数
  {
    name: 'PAGINATION_LIMIT',
    value: 10
  },
  // 字符串转大写
  {
    name: 'CASE_TO_UPPER',
    value: 1
  },
  // 字符串转小写
  {
    name: 'CASE_TO_LOWWER',
    value: 2
  },
  // 浏览器滚动条宽度
  {
    name: 'SCROLL_BAR_WIDTH',
    value: 17
  },
  // DATE 时分秒选择：精度到秒
  {
    name: 'DATE_TYPE_SECOND',
    value: 'date_type_second'
  },
  // DATE 日期选择：精度到秒
  {
    name: 'DATE_TYPE_DAY_SECOND',
    value: 'date_type_day_second'
  },
  // DATE 秒区间选择：精度到秒
  {
    name: 'DATE_TYPE_RANGE_DAY_SECOND',
    value: 'date_type_range_day_second'
  },
  // DATE 分区间选择：精度到分
  {
    name: 'DATE_TYPE_RANGE_DAY_MINUTE',
    value: 'date_type_range_day_minute'
  },
  // DATE 日期选择：精度到日
  {
    name: 'DATE_TYPE_DAY',
    value: 'date_type_day'
  },
  // DATE 日期区间选择：精度到日
  {
    name: 'DATE_TYPE_RANGE_DAY',
    value: 'date_type_range_day'
  },
  // DATE 星期选择：精度到星期
  {
    name: 'DATE_TYPE_WEEK',
    value: 'date_type_week'
  },
  // DATE 星期区间选择：精度到星期
  {
    name: 'DATE_TYPE_RANGE_WEEK',
    value: 'date_type_range_week'
  },
  // DATE 月份选择：精度到月份
  {
    name: 'DATE_TYPE_MONTH',
    value: 'date_type_month'
  },
  // DATE 月份区间选择：精度到月份
  {
    name: 'DATE_TYPE_RANGE_MONTH',
    value: 'date_type_range_month'
  },
  // DATE 季度选择：精度到季度
  {
    name: 'DATE_TYPE_QUARTER',
    value: 'date_type_quarter'
  },
  // DATE 季度区间选择：精度到季度
  {
    name: 'DATE_TYPE_RANGE_QUARTER',
    value: 'date_type_range_quarter'
  },
  // DATE 年度选择：精度到年份
  {
    name: 'DATE_TYPE_YEAR',
    value: 'date_type_year'
  },
  // DATE 年度区间选择：精度到年份
  {
    name: 'DATE_TYPE_RANGE_YEAR',
    value: 'date_type_range_year'
  },
  // 幅宽：自动
  {
    name: 'RANGE_AUTO',
    value: 'range_auto'
  },
  // 幅宽：手动
  {
    name: 'RANGE_CUSTOM',
    value: 'range_custom'
  },
  // X轴幅宽：全幅宽
  {
    name: 'X_RANGE_FULL',
    value: 'x_range_full'
  },
  // X轴幅宽：有效幅宽
  {
    name: 'X_RANGE_VALID',
    value: 'x_range_valid'
  },
  // Y轴幅宽：全幅宽（热力图）
  {
    name: 'Y_RANGE_FULL',
    value: 'y_range_full'
  },
  // Y轴幅宽：有效幅宽（热力图）
  {
    name: 'Y_RANGE_VALID',
    value: 'y_range_valid'
  },
]

export default consts